import React from 'react'
import { useFulfillment } from '../FulfillmentProvider/FulfillmentProvider'
import { useDate } from '../../hooks/useDate'

interface FutureEstimateProps {
  textClass: string
}

export const FutureEstimate: React.FC<FutureEstimateProps> = ({
  textClass
}) => {
  const { fulfillmentDateTime, matchingTimeSlot } = useFulfillment()
  const { toRelativeDateString, toFormattedTimeRange } = useDate()

  const fulTime = fulfillmentDateTime || new Date().toISOString()
  const date = toRelativeDateString(fulTime)

  // if timeslot isn't valid, display saved date for now.
  // Cart validation will force user to select a valid time
  const time = toFormattedTimeRange(
    matchingTimeSlot ||
      (fulfillmentDateTime ? { time: fulfillmentDateTime } : undefined)
  )

  return (
    <>
      <span
        data-testid='fulfillment-scheduled-ready-date'
        className={textClass}
      >
        {date}
      </span>
      ,
      <span
        data-testid='fulfillment-scheduled-ready-time'
        className={`whitespace-nowrap ${textClass}`}
      >
        &nbsp;{time}
      </span>
    </>
  )
}
